module.exports = __webpack_public_path__ + "img/growthAbility5.41d63f7c.png";